/** Maps API discussion `type` (forum channel) to sidebar tab key. */
const DISCUSSION_TYPE_TO_SIDEBAR_TAB: Record<string, string> = {
  GETTING_STARTED: 'getting-started',
  PUBLIC: 'public',
  GENERAL: 'general',
  PRODUCT_FEEDBACK: 'feedback',
  FEEDBACK: 'feedback',
  PRODUCT_ANNOUNCEMENTS: 'announcement',
  ANNOUNCEMENT: 'announcement',
  ANNOUNCEMENTS: 'announcement',
};

/** Sidebar category tabs (forum channels). */
export const DISCUSSION_CATEGORY_SIDEBAR_TABS = new Set([
  'getting-started',
  'public',
  'general',
  'feedback',
  'announcement',
]);

/** Resolve sidebar tab from API `type` / `discussion_type`. */
export function discussionTypeToSidebarTab(
  type: string | null | undefined,
): string {
  if (!type || !String(type).trim()) return '';
  const normalized = String(type).trim().toUpperCase();
  return DISCUSSION_TYPE_TO_SIDEBAR_TAB[normalized] ?? '';
}

const DISCUSSION_SIDEBAR_TAB_DISPLAY_LABELS: Record<string, string> = {
  'getting-started': 'Getting Started',
  public: 'Public',
  general: 'General',
  feedback: 'Feedback',
  announcement: 'Announcements',
};

/** Human-readable label for API discussion `type` (forum channel). */
export function discussionTypeToDisplayLabel(
  type: string | null | undefined,
): string {
  if (!type || !String(type).trim()) return '';
  const tab = discussionTypeToSidebarTab(type);
  if (tab && DISCUSSION_SIDEBAR_TAB_DISPLAY_LABELS[tab]) {
    return DISCUSSION_SIDEBAR_TAB_DISPLAY_LABELS[tab];
  }
  return String(type)
    .trim()
    .replace(/[\s_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
